exports.Customer = require('./CustomerSchema');


// WEBPACK FOOTER //
// ./schemas/customer/index.js